import { render } from "./CadastroCotacoesView.vue?vue&type=template&id=5dd89d36"
import script from "./CadastroCotacoesView.vue?vue&type=script&lang=js"
export * from "./CadastroCotacoesView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\SGCAD25\\Domus Fiança\\FrontBack\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__